<template>
    <div
        v-if="visible"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
    >
        <div class="bg-[#1F1444] rounded-2xl w-[90%] p-5 text-white shadow-xl animate-[fadeIn_0.3s_ease-out_forwards]">
            <div class="space-y-3">
                <div
                    v-for="lang in languages"
                    :key="lang.code"
                    class="flex items-center justify-between bg-[#2C255C] p-3 rounded-lg cursor-pointer hover:bg-[#3A3370]"
                    @click="selectLanguage(lang.code)"
                >
                    <div class="flex items-center gap-3">
                        <img
                            :src="lang.flag"
                            alt=""
                            class="w-6 h-6"
                        />
                        <span>{{ lang.name }}</span>
                    </div>
                    <div>
                        <div
                            class="w-5 h-5 rounded-full border-2"
                            :class="selectedLang === lang.code
                                ? 'border-purple-400 bg-purple-500'
                                : 'border-gray-400'"
                        ></div>
                    </div>
                </div>
            </div>

            <div class="flex justify-between mt-5">
                <button
                    class="px-4 py-2 border border-purple-400 text-purple-400 !rounded-full whitespace-nowrap"
                    @click="$emit('close')"
                >
                    {{ $t('cancel') }}
                </button>
                <button
                    class="px-4 py-2 bg-purple-500 !rounded-full whitespace-nowrap"
                    @click="confirmChange"
                >
                    {{ $t('confirm') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            selectedLang: "en",
        };
    },
    computed: {
        languages() {
            return [
                {
                    code: "en",
                    name: "English",
                    flag: "https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png",
                },
                {
                    code: "cn",
                    name: this.$t("cn"),
                    flag: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png",
                },
                {
                    code: "mm",
                    name: "မြန်မာ",
                    flag: "https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png",
                },
                {
                    code: "th",
                    name: "ภาษาไทย",
                    flag: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png",
                },
            ];
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.selectedLang = localStorage.getItem("language") || "en";
            }
        }
    },
    methods: {
        selectLanguage(code) {
            // console.log("CODE", code)
            this.selectedLang = code;
        },
        confirmChange() {
            localStorage.setItem("language", this.selectedLang);
            this.$store.commit("setLanguage", this.selectedLang);
            this.$i18n.locale = this.selectedLang;
            this.$emit("close");
        },
    },
};
</script>


<style scoped>
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
